export enum NavigationType {
  Sidebar,
  Tabs,
}
